export const isSafeCheckoutUrl = (value: unknown): value is string => {
  if (typeof value !== 'string' || value === '' || value !== value.trim()) return false;
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return false;
  }
  return (
    url.protocol === 'https:' &&
    url.hostname !== '' &&
    url.username === '' &&
    url.password === ''
  );
};
